import { render, staticRenderFns } from "./BadgeGraph.vue?vue&type=template&id=3470546d&"
import script from "./BadgeGraph.vue?vue&type=script&lang=js&"
export * from "./BadgeGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports